// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetCasePayorResponseModelBenefitData {
    static getAttributeTypeMap() {
        return GetCasePayorResponseModelBenefitData.attributeTypeMap;
    }
}
GetCasePayorResponseModelBenefitData.discriminator = undefined;
GetCasePayorResponseModelBenefitData.attributeTypeMap = [
    {
        "name": "caseId",
        "baseName": "caseId",
        "type": "number"
    },
    {
        "name": "payorId",
        "baseName": "payorId",
        "type": "number"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    },
    {
        "name": "coverageOrder",
        "baseName": "coverageOrder",
        "type": "number"
    },
    {
        "name": "createDate",
        "baseName": "createDate",
        "type": "Date"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "policyEligibleStatusId",
        "baseName": "policyEligibleStatusId",
        "type": "number"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "policyHolderFirstName",
        "baseName": "policyHolderFirstName",
        "type": "string"
    },
    {
        "name": "policyHolderLastName",
        "baseName": "policyHolderLastName",
        "type": "string"
    },
    {
        "name": "relationshipToPatient",
        "baseName": "relationshipToPatient",
        "type": "RoleType"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "extension",
        "baseName": "extension",
        "type": "string"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "policyNumber",
        "baseName": "policyNumber",
        "type": "string"
    },
    {
        "name": "employer",
        "baseName": "employer",
        "type": "string"
    },
    {
        "name": "personCode",
        "baseName": "personCode",
        "type": "string"
    },
    {
        "name": "planType",
        "baseName": "planType",
        "type": "PlanType"
    },
    {
        "name": "planEffectiveDate",
        "baseName": "planEffectiveDate",
        "type": "Date"
    },
    {
        "name": "planExpirationDate",
        "baseName": "planExpirationDate",
        "type": "Date"
    },
    {
        "name": "planTerminationDate",
        "baseName": "planTerminationDate",
        "type": "Date"
    }
];
//# sourceMappingURL=getCasePayorResponseModelBenefitData.js.map